import Enum from '@square/dashboard-utilities/utils/enum';
export const SetUpItemsStepNames = Enum.create('CREATE_ITEM', 'NAME_ITEM', 'ASSIGN_CATEGORY', 'ENTER_PRICE', 'CUSTOMIZE_ITEM', 'SAVE_ITEM');